import React from 'react';
import { Link } from 'react-router';
import {
  Row,
  Col,
  Button,
  Image,
  FormControl,
  Glyphicon
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import editcampaign from '../../images/edit-campaign.png';
import PaginatedList from '../../components/PaginatedList';

export default class CustomerSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: ''
    };
    //this.updateFilterValue = this.updateFilterValue.bind(this);
  }

  componentDidMount() {
    this.props.getCustomers();
  }

  updateFilterValue(event) {
    this.props.getFilteredCustomers(event.target.value || '');
  }

  moveFocusToHeading = item => {
    this.setState({ currentItemName: item.name }, () =>
      this.screenReaderContent.focus()
    );
  };

  render() {
    const customerId = this.props.params.customerId || 'new';

    const LineItem = props => {
      const customer = props.item;
      return (
        <Row
          key={customer.id}
          className={`sidebar-list-item customers ${customer.isArchived &&
            'archived'}`}
          onClick={e => this.moveFocusToHeading(customer)}
        >
          <Link to={`/customers/${customer.id}`}>
            <Col
              sm={10}
              className={`overflow-ellipsis map-link ${customerId ===
                customer.id.toString() && 'active'}`}
            >
              <p title={customer.name}>
                <strong>{customer.name}</strong>
              </p>
              <div
                className="sidebar-list-item__abn"
                title={`ABN ${customer.abn}`}
              >
                ABN: {customer.abn}
              </div>
              <small title={`Created by ${customer.createdBy}`}>
                Created by {customer.createdBy}
              </small>
            </Col>
          </Link>
          <Link to={`/customers/${customer.id}`}>
            <Col sm={2} className="edit-btn text-center campaign-edit-link">
              <Image src={editcampaign} responsive alt="Edit Campaign" />
              <span className="campaign-edit-link-text">Edit</span>
            </Col>
          </Link>
        </Row>
      );
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12} md={7}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Editing customer {this.state.currentItemName}
            </h3>
            <h1>Customers</h1>
          </Col>

          <Col sm={12} md={7}>
            <div className="sidebar-new-btn">
              <LinkContainer to="/customers/new">
                <Button bsStyle="primary" className="new-btn">
                  Create New
                </Button>
              </LinkContainer>
            </div>
          </Col>

          <Col sm={12}>
            <div className="filter-box">
              <FormControl
                placeholder="Filter"
                onChange={this.updateFilterValue.bind(this)}
              />
              <Button type="submit" className="search">
                <Glyphicon glyph="search" />
              </Button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <PaginatedList
              filterValue={this.state.filterValue}
              itemsPerPage={10}
              component={LineItem}
              pageButtonLimit={5}
              items={this.props.customers}
              showArchived={this.state.showArchived}
              pluralName="customers"
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12} className="show-archived-wrapper">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="archiveCheckbox"
                id="archiveCheckbox"
                className="archive-checkbox"
                checked={this.state.showArchived}
                onChange={() =>
                  this.setState({ showArchived: !this.state.showArchived })
                }
              />
              <label htmlFor="archiveCheckbox" className="checkbox-label">
                Show Archived
              </label>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/customer/CustomerSidebar.js